import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import "./ErrorMessageElement.scss";
import { ErrorProps } from './IErrorMessage';

const ErrorMessageElement = (props: ErrorProps) => {
  const ref = useRef<HTMLDivElement>();
  const [messages, setMessages] = useState(props.messages);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (props.messages.length === 0) {
      props.setErrorMessageBoxHeight(0);
      setShow(false);
      return;
    }
    setMessages(props.messages);
  }, [props.messages]);

  useEffect(() => {
    if (messages.length === 0) return;
    const height = ref.current?.getBoundingClientRect()?.height;
    props.setErrorMessageBoxHeight(height || 0);
    setShow(true);
  }, [messages]);
  
  return (
    <div
      ref={ref}
      className={"error-messages" + (show ? " show" : "")}
    >
      <div className="container">
        {messages && messages.length > 0 && messages.map((message, i) => (
          <div key={"valid" + i} className="error-message">
            {message.text}
          </div>
        ))}
      </div>
    </div>
  )
}

export default ErrorMessageElement;